<template>
  <v-card
    class="delivery-by-day mx-auto pa-2"
    outlined
  >
    <v-list-item>
      <v-list-item-content class="overflow-visible">
        <v-list-item-title class="headline mb-2">
          Báo cáo giao hàng theo ngày
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <div
        v-if="!_.isEmpty(dayReport.labels)"
    >
      <chartist
        v-if="!loadingReportByDay"
        ratio="ct-major-second"
        type="Bar"
        :data="dayReport"
        :options="chartOptions"
        class="chart-fix"
      >
      </chartist>

      <ul class="description">
        <li v-for="(item, index) in dayReport.statusDeliveries" :key="index" class="d-inline-flex align-items-center">
          <v-avatar
            tile
            v-bind:style="{'background-color':dayReport.color[item.key % 12]}"
            size="20"
            class="mx-1"
          />
          {{item.value}}
        </li>
      </ul>
    </div>
    <common-no-result
      v-else
    />

  </v-card>
</template>

<script>
import * as ChartistTooltips from 'chartist-plugin-tooltips';
import { formatPrice } from '@/helpers/utils'
import moment from 'moment'


  export default {
    props: {
      dayReport: {
        default: () => ({})
      },
      loadingReportByDay: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        chartOptions: {
          stackBars: true,
          fullWidth: true,
          height: 300,
          chartPadding: {
            right: 50,
            left: 50
          },
          axisY: {
            offset: 50,
            labelInterpolationFnc: (value) => {
              if(value.toFixed(0) <= 100) {
                return (value.toFixed(0)).toString() + '%';
              }
            },
            scaleMinSpace: 15
          },
          axisX: {
            labelInterpolationFnc: (value) => {
              return moment(value, 'DD/MM/YYYY').format('DD-MM')
            },
          },
          plugins: [this.$chartist.plugins.tooltip(
            {
              currency: ' ',
              tooltipFnc: function(val1, val2) {
                let temp = val1.split(',');
                return temp[0] + '<br>Tỷ lệ: ' + val2 + '%<br>' + temp[1]
              }
            }
          )]
        },
      }
    },
    created() {
    },
    methods: {

    },
  }
</script>

<style lang="scss">
  .delivery-by-day {
    .ct-series-a .ct-bar,
    .ct-series-a .ct-line {
      stroke: green;
    }

    .ct-series-b .ct-bar,
    .ct-series-b .ct-line {
      stroke: yellow;
    }

    .ct-series-c .ct-bar,
    .ct-series-c .ct-line {
      stroke: red;
    }

    .ct-series-d .ct-bar,
    .ct-series-d .ct-line {
      stroke: aqua;
    }

    .ct-series-e .ct-bar,
    .ct-series-e .ct-line {
      stroke: teal;
    }

    .ct-series-f .ct-bar,
    .ct-series-f .ct-line {
      stroke: hotpink;
    }

    .ct-series-g .ct-bar,
    .ct-series-g .ct-line {
      stroke: darkgrey;
    }

    .ct-series-h .ct-bar,
    .ct-series-h .ct-line {
      stroke: gold;
    }

    .ct-series-i .ct-bar,
    .ct-series-i .ct-line {
      stroke: blueviolet;
    }

    .ct-series-j .ct-bar,
    .ct-series-j .ct-line {
      stroke: maroon;
    }

    .ct-label {
      fill: white;
    }
    .chart-fix .ct-label.ct-label.ct-horizontal.ct-end {
      left: 50%;
    }
    .ct-bar {
      stroke-width: 30px;
    }
  }
</style>
